import React, { Fragment } from "react";
import { faEnvelopeOpen, faPhone, faSms } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CallWindowConfigForm } from "./CallWindowConfigForm";
import { getChannelFlagColor } from "../../../utils/normalize";

import moment from "moment";

export const expandCallWindowConfigRow = (
  onSave,
  showLoader,
  nonExpandableRowKeys,
  isInternalUser,
  expandableKeys,
  hasUpdatePermission
) => ({
  onlyOneExpanding: false,
  showExpandColumn: true,
  expanded: expandableKeys,
  nonExpandable: nonExpandableRowKeys,
  renderer: (selectedCampaign) => (
    <CallWindowConfigForm
      onSave={onSave}
      onChange={() => {}}
      selectedCampaign={selectedCampaign}
      showLoader={showLoader}
      isInternalUser={isInternalUser}
      hasUpdatePermission={hasUpdatePermission}
    />
  ),
});

export const campaignTableSchema = () => [
  {
    dataField: "id",
    text: "TemplateId",
    hidden: true,
  },
  {
    dataField: "company_code",
    text: "Company Code",
    sort: true,
  },
  {
    dataField: "type",
    text: "Type",
    sort: true,
  },
  {
    dataField: "subtype",
    text: "Subtype",
    sort: true,
  },
  {
    dataField: "Channel",
    text: "Channel",
    isDummyField: true,
    headerStyle: () => ({ width: "100px" }),
    formatter: (cell, rowData) => (
      <div className="text-nowrap">
        <Fragment>
          <FontAwesomeIcon
            icon={faSms}
            size="lg"
            color={getChannelFlagColor(rowData.sms)}
            className="mr-3"
          />
          <FontAwesomeIcon
            icon={faEnvelopeOpen}
            size="lg"
            color={getChannelFlagColor(rowData.email)}
            className="mr-3"
          />
          <FontAwesomeIcon
            icon={faPhone}
            size="lg"
            color={getChannelFlagColor(rowData.voice)}
            className="mr-3"
          />
        </Fragment>
      </div>
    ),
  },
  {
    dataField: "updated_at",
    text: "Updated At",
    sort: false,
    formatter: (updated_at) => (updated_at ? moment(updated_at).format("lll") : ""),
  },
  {
    dataField: "updated_by",
    text: "Updated By",
    isDummyField: true,
    sort: false,
    formatter: (cell, rowData) =>
      (rowData.firstname_vch || " ") + " " + (rowData.lastname_vch || " "),
  },
  {
    dataField: "user_id_bint",
    text: "Updated By Id",
    sort: true,
    hidden: true,
  },
];
